export default __webpack_public_path__ + "static/media/thoth-logo.1a28a729.png";